module.exports = " <div class=\"languageselect\"> <li><a ng-click=\"vm.langDe()\" class=\"btn-link\">De</a></li> <li><a ng-click=\"vm.langFr()\" class=\"btn-link\">Fr</a></li> <li><a ng-click=\"vm.langIt()\" class=\"btn-link\">It</a></li> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/core/component/dv-languageselect/dv-languageselect.html
// module id = gtL8
// module chunks = 0